// extracted by mini-css-extract-plugin
export default {"card_container":"ReportViewPage_card_container__onftM","card":"ReportViewPage_card__8+FRp"};